import BaseAccordion from "@/components_v2/Accordion/BaseAccordion";
import { AccordionVariant } from "@/components_v2/Accordion/types";
import { AnalyticsSectionsProps } from "@/features/certifications/analytics/types";

import "../styles.css";

const AnalyticsSections = ({ sections }: AnalyticsSectionsProps) => (
  <BaseAccordion
    className="analytics-sections"
    variant={AccordionVariant.TRANSPARENT}
    ghost
    defaultActiveKey={sections.map((section) => section.key)}
    items={sections.map((section) => ({
      key: section.key,
      label: (
        <span className="flex flex-wrap items-baseline gap-200">
          <span className="analytics-section-title header-s-medium">
            {section.title}
          </span>

          <span className="analytics-muted body-xs-regular">
            {section.scope}
          </span>
        </span>
      ),
      children: (
        <div className="analytics-grid flex flex-wrap items-start gap-400">
          {section.children}
        </div>
      ),
    }))}
  />
);

export default AnalyticsSections;
